import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-layered-beauty',
  templateUrl: './layered-beauty.component.html',
  styleUrls: ['./layered-beauty.component.scss']
})
export class LayeredBeautyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
